import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonWorkerOverview, CommonWorkerTopics } from "../../CommonComponents/CommonWorkerViews";

export const InfrastructureWorkerConnectivityRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.workerMachine.connection,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonWorkerTopics />;
    },
};
